import { graphql } from 'react-relay';

/**
 * The agent-site catalogue for the "Run crawl → single site" picker
 * (pv-frontend#163). Each site carries `isCrawlable` — the same gate the crawler
 * enforces (approved robots + ToS, not opted out) — so the picker can mark which
 * sites a single-site run would actually fetch.
 */
export const crawlSitesQuery = graphql`
    query crawlSitesQuery {
        crawlSites {
            id
            name
            areasServed
            isCrawlable
        }
    }
`;
